(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adres-assistant"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-adres-assistant]:not([data-adres-assistant-ready])');

    roots.forEach((root) => {
      root.setAttribute('data-adres-assistant-ready', 'true');

      const configElement = root.querySelector('[data-adres-assistant-config]');
      const launcher = root.querySelector('[data-adres-assistant-launcher]');
      const dialog = root.querySelector('[data-adres-assistant-dialog]');
      const closeButton = root.querySelector('[data-adres-assistant-close]');
      const messages = root.querySelector('[data-adres-assistant-messages]');
      const form = root.querySelector('[data-adres-assistant-form]');
      const input = root.querySelector('[data-adres-assistant-input]');
      const sendButton = root.querySelector('[data-adres-assistant-send]');
      const cartSummary = root.querySelector('[data-adres-assistant-cart-summary]');

      if (!configElement || !launcher || !dialog || !closeButton || !messages || !form || !input || !sendButton) {
        return;
      }

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        launcher.hidden = true;
        return;
      }

      let moneyFormatter;
      try {
        moneyFormatter = new Intl.NumberFormat(config.locale || document.documentElement.lang || 'tr-TR', {
          style: 'currency',
          currency: config.currency || 'TRY',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } catch (error) {
        moneyFormatter = new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: 'TRY',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      const trustedProductHosts = new Set(
        (config.trustedProductHosts || []).filter(Boolean).map((host) => String(host).toLowerCase())
      );
      trustedProductHosts.add(window.location.hostname.toLowerCase());

      let sessionId = readSessionId();
      let lastProducts = [];
      let isSending = false;
      let cartLoaded = false;
      let previousFocus = null;

      function createSessionId() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
        return `assistant-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      }

      function readSessionId() {
        try {
          const storedSession = window.sessionStorage.getItem('adresAssistantSessionId');
          if (storedSession) {
            return storedSession;
          }
        } catch (error) {
          return createSessionId();
        }
        return createSessionId();
      }

      function saveSessionId(value) {
        sessionId = value || sessionId;
        try {
          window.sessionStorage.setItem('adresAssistantSessionId', sessionId);
        } catch (error) {
          return;
        }
      }

      function transition(callback) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let callbackStarted = false;
        const runCallback = () => {
          if (callbackStarted) {
            return;
          }
          callbackStarted = true;
          callback();
        };
        if (document.startViewTransition && !reducedMotion) {
          try {
            const viewTransition = document.startViewTransition(runCallback);
            viewTransition.ready.catch(() => undefined);
            viewTransition.updateCallbackDone.catch(() => runCallback());
            viewTransition.finished.catch(() => undefined);
            return;
          } catch (error) {
            runCallback();
            return;
          }
        }
        runCallback();
      }

      function track(eventName, detail) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
      }

      function scrollMessages() {
        window.requestAnimationFrame(() => {
          messages.scrollTop = messages.scrollHeight;
        });
      }

      function normalizeAssistantReply(value) {
        return String(value || '')
          .replace(/\*\*([^*\r\n]+)\*\*/g, '$1')
          .replace(/\*\*/g, '');
      }

      function addMessage(role, text, status) {
        const message = document.createElement('div');
        const bubble = document.createElement('div');
        message.className = `adres-assistant__message adres-assistant__message--${role}`;
        if (status) {
          message.classList.add('adres-assistant__message--status');
        }
        bubble.className = 'adres-assistant__bubble';
        bubble.textContent = role === 'assistant'
          ? normalizeAssistantReply(text)
          : String(text || '');
        message.appendChild(bubble);
        messages.appendChild(message);
        scrollMessages();
        return message;
      }

      function addAction(message, label, href, primary) {
        let actions = message.querySelector('.adres-assistant__message-actions');
        if (!actions) {
          actions = document.createElement('div');
          actions.className = 'adres-assistant__message-actions';
          message.appendChild(actions);
        }
        const link = document.createElement('a');
        link.className = 'adres-assistant__action';
        if (primary) {
          link.classList.add('adres-assistant__action--primary');
        }
        link.href = href;
        link.textContent = label;
        actions.appendChild(link);
        return link;
      }

      function safeWhatsappUrl(value) {
        try {
          const url = new URL(value, window.location.origin);
          const hostname = url.hostname.toLowerCase();
          const expectedNumber = String(config.whatsappNumber || '').replace(/\D/g, '');
          if (url.protocol !== 'https:') {
            return null;
          }
          if (!['api.whatsapp.com', 'wa.me'].includes(hostname) || !expectedNumber) {
            return null;
          }
          const actualNumber = hostname === 'wa.me'
            ? url.pathname.replace(/\D/g, '')
            : String(url.searchParams.get('phone') || '').replace(/\D/g, '');
          if (actualNumber !== expectedNumber) {
            return null;
          }
          return url.href;
        } catch (error) {
          return null;
        }
      }

      function safeProductUrl(value) {
        if (typeof value !== 'string' || !value.trim() || value.length > 2048) {
          return null;
        }
        try {
          const url = new URL(value.trim(), window.location.origin);
          if (url.protocol !== 'https:' || url.username || url.password || url.port) {
            return null;
          }
          if (!trustedProductHosts.has(url.hostname.toLowerCase())) {
            return null;
          }

          const decodedPath = decodeURIComponent(url.pathname).normalize('NFC');
          const pathMatch = /^\/(?:([A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*)\/)?products\/([^/]+)\/?$/u.exec(decodedPath);
          if (!pathMatch) {
            return null;
          }

          const handle = pathMatch[2];
          if (!/^[\p{L}\p{N}][\p{L}\p{N}\p{M}_-]{0,254}$/u.test(handle)) {
            return null;
          }

          url.pathname = decodedPath;
          url.search = '';
          url.hash = '';
          return url;
        } catch (error) {
          return null;
        }
      }

      function safeCollectionUrl(value) {
        if (typeof value !== 'string' || !value.trim() || value.length > 2048) {
          return null;
        }
        try {
          const url = new URL(value.trim(), window.location.origin);
          if (url.protocol !== 'https:' || url.username || url.password || url.port) {
            return null;
          }
          if (!trustedProductHosts.has(url.hostname.toLowerCase())) {
            return null;
          }

          const decodedPath = decodeURIComponent(url.pathname).normalize('NFC');
          const pathMatch = /^\/(?:([A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*)\/)?collections\/([^/]+)\/?$/u.exec(decodedPath);
          if (!pathMatch) {
            return null;
          }

          const handle = pathMatch[2];
          if (!/^[\p{L}\p{N}][\p{L}\p{N}\p{M}_-]{0,254}$/u.test(handle)) {
            return null;
          }

          url.pathname = decodedPath;
          url.search = '';
          url.hash = '';
          return url;
        } catch (error) {
          return null;
        }
      }

      function safeImageUrl(value) {
        if (!value) {
          return null;
        }
        try {
          const url = new URL(value, window.location.origin);
          return url.protocol === 'https:' ? url.href : null;
        } catch (error) {
          return null;
        }
      }

      function formatPredictivePrice(value) {
        const numericPrice = Number(value);
        if (!Number.isFinite(numericPrice) || numericPrice <= 0) {
          return '';
        }
        const formattedPrice = moneyFormatter.format(numericPrice);
        return String(config.currency || 'TRY').toUpperCase() === 'TRY'
          ? formattedPrice.replace('₺', 'TL')
          : formattedPrice;
      }

      function formatCartPrice(value) {
        const numericPrice = Number(value) / 100;
        if (!Number.isFinite(numericPrice)) {
          return '';
        }
        const formattedPrice = moneyFormatter.format(numericPrice);
        return String(config.currency || 'TRY').toUpperCase() === 'TRY'
          ? formattedPrice.replace('₺', 'TL')
          : formattedPrice;
      }

      function getProductImage(product) {
        if (!product || !product.image) {
          return null;
        }
        if (typeof product.image === 'string') {
          return safeImageUrl(product.image);
        }
        return safeImageUrl(product.image.url || product.image.src);
      }

      function normalizeProduct(product) {
        const url = safeProductUrl(product && product.url);
        const title = String((product && product.title) || '').trim().slice(0, 240);
        const id = String((product && product.id) || '').trim().slice(0, 80);
        if (!url || !title || !id) {
          return null;
        }
        return {
          id,
          title,
          url: url.href,
          path: url.pathname,
          price: formatPredictivePrice(product.price),
          image: getProductImage(product),
          available: product.available !== false
        };
      }

      function normalizeCollection(collection) {
        const url = safeCollectionUrl(collection && collection.url);
        const title = String((collection && collection.title) || '').trim().slice(0, 160);
        if (!url || !title) {
          return null;
        }
        return { title, url: url.href };
      }

      function normalizeCatalogText(value) {
        return String(value || '')
          .toLocaleLowerCase('tr-TR')
          .replace(/ı/g, 'i')
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      function getMenuCollections() {
        const collectionsByUrl = new Map();
        (Array.isArray(config.menuCollections) ? config.menuCollections : []).forEach((collection) => {
          const normalized = normalizeCollection(collection);
          if (normalized && !collectionsByUrl.has(normalized.url)) {
            collectionsByUrl.set(normalized.url, normalized);
          }
        });
        return Array.from(collectionsByUrl.values());
      }

      function normalizeCategoryToken(token) {
        const aliases = {
          baglama: 'baglamali',
          strapon: 'belden-baglamali',
          strap: 'belden-baglamali'
        };
        const singular = String(token || '').replace(/(?:lar|ler)$/u, '');
        return aliases[singular] || singular;
      }

      function getCategoryTokens(value) {
        const ignoredTokens = new Set(['bir', 'icin', 'istiyorum', 'oner', 'onerir', 'oneriniz', 'urun', 'urunler', 'bana', 'ariyorum', 'bakiyorum', 'lazim']);
        return normalizeCatalogText(value)
          .split(' ')
          .flatMap((token) => normalizeCategoryToken(token).split('-'))
          .filter((token) => token.length > 1 && !ignoredTokens.has(token));
      }

      function findCategoryCollections(query, collections) {
        const queryTokens = new Set(getCategoryTokens(query));
        if (!queryTokens.size) {
          return [];
        }

        const scored = collections.map((collection, index) => {
          const titleTokens = [...new Set(getCategoryTokens(collection.title))];
          const matchedTokens = titleTokens.filter((token) => queryTokens.has(token));
          const coverage = titleTokens.length ? matchedTokens.length / titleTokens.length : 0;
          const score = coverage >= 0.5 ? Math.round(coverage * 100) + (matchedTokens.length * 10) : 0;
          return { collection, index, score };
        }).filter((entry) => entry.score > 0);

        if (!scored.length) {
          return [];
        }

        const bestScore = Math.max(...scored.map((entry) => entry.score));
        return scored
          .filter((entry) => entry.score === bestScore)
          .sort((left, right) => left.index - right.index)
          .slice(0, 3)
          .map((entry) => entry.collection);
      }

      function renderCollectionLinks(collections, message, eventName) {
        if (!collections.length) {
          return false;
        }

        const fallbackMessage = addMessage('assistant', message);
        const links = document.createElement('div');
        links.className = 'adres-assistant__collection-links';
        collections.forEach((collection) => {
          const link = document.createElement('a');
          link.className = 'adres-assistant__collection-link';
          link.href = collection.url;
          link.textContent = collection.title;
          link.setAttribute('aria-label', `${config.strings.viewCollection}: ${collection.title}`);
          links.appendChild(link);
        });
        fallbackMessage.appendChild(links);
        track(eventName, { collection_count: collections.length });
        scrollMessages();
        return true;
      }

      function renderCategoryCollection(query) {
        const collections = getMenuCollections();
        return renderCollectionLinks(
          findCategoryCollections(query, collections),
          config.strings.collectionMatch,
          'adres_assistant_collection_match'
        );
      }

      function renderCollectionFallback(query) {
        const collections = getMenuCollections();
        const matching = findCategoryCollections(query, collections);
        return renderCollectionLinks(
          matching.length ? matching : collections.slice(0, 6),
          config.strings.collectionFallback,
          'adres_assistant_collection_fallback'
        );
      }

      function looksSensitive(value) {
        const text = String(value || '');
        const phonePattern = /(?:\+?90|0)?[\s.-]*\(?(?:5\d{2}|[2-4]\d{2})\)?[\s.-]*\d{3}[\s.-]*\d{2}[\s.-]*\d{2}/;
        const emailPattern = /[\w.+-]+@[\w-]+\.[\w.-]+/i;
        const personalAddressPattern = /\b(?:adresim|adresimi|ev adresim|evimin adresi|teslimat adresim|oturduğum|oturdugum|yaşadığım|yasadigim)\b/i;
        const addressHints = text.match(/\b(?:mahalle|mahallesi|cadde|caddesi|sokak|sokağı|sokagi|apartman|daire|adres)\b/gi) || [];
        const addressPattern = personalAddressPattern.test(text) || (
          addressHints.length > 0 && (addressHints.length >= 2 || (text.match(/\d/g) || []).length >= 3)
        );
        const cardPattern = /(?:^|\D)(?:\d[\s-]?){13,19}(?:\D|$)/;
        return phonePattern.test(text) || emailPattern.test(text) || addressPattern || cardPattern.test(text);
      }

      async function fetchJson(url, options, timeoutMs) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), timeoutMs || 10000);
        try {
          const response = await fetch(url, Object.assign({}, options || {}, {
            signal: controller.signal
          }));
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            const message = String(data.description || data.reply_text || data.error || config.strings.error).slice(0, 300);
            const requestError = new Error(message);
            requestError.status = response.status;
            throw requestError;
          }
          return data;
        } finally {
          window.clearTimeout(timeout);
        }
      }

      function updateCart(cart) {
        const itemCount = Number(cart && cart.item_count) || 0;
        const totalPrice = Number(cart && cart.total_price) || 0;
        const total = formatCartPrice(totalPrice);
        if (cartSummary) {
          cartSummary.textContent = itemCount > 0
            ? config.strings.cartSummaryTemplate
              .replace('__COUNT__', String(itemCount))
              .replace('__TOTAL__', total)
            : config.strings.cartEmpty;
        }
        document.querySelectorAll('#CartCount, [data-cart-count], .site-header__cart-count').forEach((element) => {
          element.textContent = String(itemCount);
        });
        document.dispatchEvent(new CustomEvent('adres-assistant:cart-updated', {
          detail: { itemCount, totalPrice }
        }));
      }

      async function refreshCart() {
        const cart = await fetchJson(config.cartJsonUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }, 8000);
        updateCart(cart);
        cartLoaded = true;
        return cart;
      }

      function renderPurchaseActions(message) {
        addAction(message, config.strings.viewCart, config.cartUrl, false);
        addAction(message, config.strings.checkout, config.checkoutUrl, true);
      }

      async function addProductToCart(product, button) {
        if (button.dataset.chooseOptions === 'true') {
          window.location.assign(product.url);
          return;
        }

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        let keepDisabled = false;

        try {
          const productData = await fetchJson(`${product.path}.js`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }, 8000);
          const variants = Array.isArray(productData.variants) ? productData.variants : [];
          const availableVariants = variants.filter((variant) => variant && variant.available);

          if (!availableVariants.length) {
            addMessage('assistant', config.strings.soldOut);
            keepDisabled = true;
            return;
          }

          if (variants.length !== 1) {
            const optionMessage = addMessage('assistant', config.strings.optionRequired);
            addAction(optionMessage, config.strings.chooseOptions, product.url, true);
            button.dataset.chooseOptions = 'true';
            button.textContent = config.strings.chooseOptions;
            return;
          }

          const variant = availableVariants[0];
          const beforeCart = await refreshCart();
          const beforeQuantity = (beforeCart.items || []).reduce((total, item) => {
            return String(item.variant_id) === String(variant.id) ? total + Number(item.quantity || 0) : total;
          }, 0);

          await fetchJson(config.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variant.id, quantity: 1 }]
            })
          }, 10000);

          const afterCart = await refreshCart();
          const afterQuantity = (afterCart.items || []).reduce((total, item) => {
            return String(item.variant_id) === String(variant.id) ? total + Number(item.quantity || 0) : total;
          }, 0);

          if (afterQuantity <= beforeQuantity) {
            throw new Error(config.strings.cartError);
          }

          const addedText = config.strings.addedTemplate
            .replace('__PRODUCT__', product.title)
            .replace('__COUNT__', String(afterQuantity));
          const successMessage = addMessage('assistant', addedText);
          renderPurchaseActions(successMessage);
          track('adres_assistant_add_to_cart_verified', { product_id: product.id });

          if (config.pageType === 'cart') {
            addMessage('assistant', config.strings.cartRefreshing, true);
            window.setTimeout(() => window.location.reload(), 900);
          }
        } catch (error) {
          const message = error.name === 'AbortError' ? config.strings.timeout : (error.message || config.strings.cartError);
          addMessage('assistant', message);
          track('adres_assistant_add_to_cart_error', { product_id: product.id });
        } finally {
          button.removeAttribute('aria-busy');
          button.disabled = keepDisabled;
        }
      }

      function renderProductResults(products, query, showCategoryLink) {
        const normalizedProducts = products.map(normalizeProduct).filter(Boolean).slice(0, 5);
        lastProducts = normalizedProducts.map((product) => ({
          id: product.id,
          title: product.title,
          price: product.price,
          url: product.url,
          available: product.available
        }));

        if (!normalizedProducts.length) {
          const emptyMessage = addMessage('assistant', config.strings.noResults);
          if (!renderCollectionFallback(query)) {
            addAction(emptyMessage, config.strings.whatsapp, config.whatsappUrl, true).target = '_blank';
          }
          return;
        }

        if (showCategoryLink !== false) {
          renderCategoryCollection(query);
        }
        const resultMessage = addMessage('assistant', config.strings.results);
        const productsList = document.createElement('div');
        productsList.className = 'adres-assistant__products';
        resultMessage.appendChild(productsList);

        normalizedProducts.forEach((product) => {
          const card = document.createElement('article');
          const imageLink = document.createElement('a');
          const titleLink = document.createElement('a');
          const price = document.createElement('div');
          const actions = document.createElement('div');
          const viewLink = document.createElement('a');
          const addButton = document.createElement('button');

          card.className = 'adres-assistant__product';
          imageLink.className = 'adres-assistant__product-image';
          imageLink.href = product.url;
          imageLink.setAttribute('aria-label', product.title);
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = product.title;
            image.loading = 'lazy';
            image.width = 240;
            image.height = 240;
            imageLink.appendChild(image);
          }

          titleLink.className = 'adres-assistant__product-title';
          titleLink.href = product.url;
          titleLink.textContent = product.title;
          price.className = 'adres-assistant__product-price';
          price.textContent = product.price;
          actions.className = 'adres-assistant__product-actions';
          viewLink.href = product.url;
          viewLink.textContent = config.strings.viewProduct;
          addButton.type = 'button';
          addButton.textContent = product.available ? config.strings.addToCart : config.strings.soldOut;
          addButton.disabled = !product.available;
          addButton.addEventListener('click', () => addProductToCart(product, addButton));

          actions.append(viewLink, addButton);
          card.append(imageLink, titleLink, price, actions);
          productsList.appendChild(card);
        });

        const allResultsUrl = new URL(config.searchUrl, window.location.origin);
        allResultsUrl.searchParams.set('q', `${query.replace(/\*+$/, '')}*`);
        allResultsUrl.searchParams.set('type', 'product');
        addAction(resultMessage, config.strings.showAll, allResultsUrl.href, false);
        track('adres_assistant_product_results', { result_count: normalizedProducts.length });
        scrollMessages();
      }

      async function searchProducts(query, showCategoryLink) {
        const normalizedQuery = String(query || '').trim().slice(0, 120);
        if (normalizedQuery.length < 2 || looksSensitive(normalizedQuery)) {
          return;
        }

        const statusMessage = addMessage('assistant', config.strings.searching, true);
        try {
          let resultQuery = normalizedQuery;
          let products = await fetchPredictiveProducts(resultQuery);
          const fallbackQuery = simplifyCatalogQuery(normalizedQuery);
          if (!products.length && fallbackQuery.length >= 2 && fallbackQuery !== normalizedQuery) {
            resultQuery = fallbackQuery;
            products = await fetchPredictiveProducts(resultQuery);
          }
          statusMessage.remove();
          renderProductResults(products, resultQuery, showCategoryLink);
        } catch (error) {
          statusMessage.remove();
          const errorMessage = addMessage('assistant', error.name === 'AbortError' ? config.strings.timeout : config.strings.productError);
          addAction(errorMessage, config.strings.whatsapp, config.whatsappUrl, true).target = '_blank';
        }
      }

      function simplifyCatalogQuery(value) {
        const conversationalTokenPattern = /^(?:(?:bak(?:ıyor|iyor)|ar(?:ıyor|iyor)|istiyor)[a-zçğıöşü]*|g[öo]ster(?:ir|ebilir)[a-zçğıöşü]*)$/i;
        const modalTokens = new Set([
          'mi', 'mı', 'mu', 'mü',
          'misin', 'mısın', 'musun', 'müsün',
          'misiniz', 'mısınız', 'musunuz', 'müsünüz'
        ]);
        const tokens = String(value || '').toLowerCase().match(/[0-9A-Za-zÇĞİÖŞÜçğıöşü]+/g) || [];
        return tokens
          .filter((token) => !modalTokens.has(token) && !conversationalTokenPattern.test(token))
          .join(' ')
          .slice(0, 120);
      }

      async function fetchPredictiveProducts(query) {
        const url = new URL(config.predictiveSearchUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        const data = await fetchJson(url.href, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }, 8000);
        return (((data || {}).resources || {}).results || {}).products || [];
      }

      function extractReplyText(data) {
        if (data && typeof data.reply_text === 'string' && data.reply_text.trim()) {
          return data.reply_text.trim();
        }
        if (data && typeof data.reply === 'string') {
          return data.reply.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        }
        return config.strings.error;
      }

      function containsHumanSupportIntent(value) {
        return /(?:whats\s*app|canl[ıi]\s+destek|canl[ıi]\s+m[üu]şteri\s+hizmetleri|m[üu]şteri\s+hizmetleri|yetkili\s+ekip|canl[ıi]\s+temsilci)/i.test(String(value || ''));
      }

      function needsWhatsappFallback(data, userMessage) {
        return containsHumanSupportIntent(extractReplyText(data)) || containsHumanSupportIntent(userMessage);
      }

      async function handleResponseActions(data, message, categoryAlreadyRendered, userMessage) {
        const actions = Array.isArray(data && data.actions) ? data.actions : [];
        let searchQuery = null;
        let hasWhatsappAction = false;

        actions.forEach((action) => {
          if (!action || typeof action !== 'object') {
            return;
          }
          if (action.type === 'search_products' && typeof action.query === 'string') {
            searchQuery = action.query;
          }
          if (action.type === 'open_whatsapp') {
            const whatsapp = safeWhatsappUrl(action.url);
            if (whatsapp) {
              const link = addAction(message, String(action.label || config.strings.whatsapp), whatsapp, true);
              link.target = '_blank';
              link.rel = 'noopener noreferrer';
              hasWhatsappAction = true;
            }
          }
        });

        if (!hasWhatsappAction && needsWhatsappFallback(data, userMessage)) {
          const whatsapp = safeWhatsappUrl(config.whatsappUrl);
          if (whatsapp) {
            const link = addAction(message, config.strings.whatsapp, whatsapp, true);
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            track('adres_assistant_whatsapp_fallback');
          }
        }

        if (searchQuery) {
          await searchProducts(searchQuery, !categoryAlreadyRendered);
        }
      }

      function buildPayload(text) {
        const payload = {
          message: text,
          session_id: sessionId,
          page_type: config.pageType,
          catalog_products: lastProducts
        };
        if (config.currentProduct) {
          payload.product_url = config.currentProduct.url;
          payload.product_title = config.currentProduct.title;
          payload.product_price = config.currentProduct.price;
          payload.product_summary = config.currentProduct.summary;
          payload.product_available = Boolean(config.currentProduct.available);
        }
        return payload;
      }

      async function sendMessage(text) {
        const normalizedText = String(text || '').trim();
        if (!normalizedText || isSending) {
          return;
        }
        if (looksSensitive(normalizedText)) {
          addMessage('assistant', config.strings.privateData);
          input.value = '';
          input.focus();
          return;
        }

        addMessage('user', normalizedText);
        input.value = '';
        isSending = true;
        sendButton.disabled = true;
        form.setAttribute('aria-busy', 'true');
        const typingMessage = addMessage('assistant', config.strings.typing, true);

        try {
          const data = await fetchJson(config.endpoint, {
            method: 'POST',
            mode: 'cors',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(buildPayload(normalizedText))
          }, 25000);
          typingMessage.remove();
          if (data.session_id) {
            saveSessionId(String(data.session_id));
          }
          const assistantMessage = addMessage('assistant', extractReplyText(data));
          const categoryRendered = renderCategoryCollection(normalizedText);
          await handleResponseActions(data, assistantMessage, categoryRendered, normalizedText);
          track('adres_assistant_message_success', { response_source: String(data.response_source || 'unknown') });
        } catch (error) {
          typingMessage.remove();
          const errorText = error.name === 'AbortError' ? config.strings.timeout : (error.message || config.strings.error);
          const errorMessage = addMessage('assistant', errorText);
          renderCategoryCollection(normalizedText);
          const whatsapp = safeWhatsappUrl(config.whatsappUrl);
          if (whatsapp) {
            const link = addAction(errorMessage, config.strings.whatsapp, whatsapp, true);
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
          }
          track('adres_assistant_message_error', { status: Number(error.status || 0) });
        } finally {
          isSending = false;
          sendButton.disabled = false;
          form.removeAttribute('aria-busy');
          input.focus();
        }
      }

      function openAssistant() {
        if (dialog.open) {
          return;
        }
        previousFocus = document.activeElement;
        transition(() => {
          dialog.showModal();
          document.documentElement.classList.add('adres-assistant-is-open');
          window.requestAnimationFrame(() => input.focus({ preventScroll: true }));
        });
        if (!cartLoaded) {
          refreshCart().catch(() => undefined);
        }
        track('adres_assistant_open');
      }

      function closeAssistant() {
        if (!dialog.open) {
          return;
        }
        transition(() => dialog.close());
      }

      launcher.addEventListener('click', openAssistant);
      closeButton.addEventListener('click', closeAssistant);
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('adres-assistant-is-open');
        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeAssistant();
        }
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        sendMessage(input.value);
      });
      root.querySelectorAll('[data-adres-assistant-prompt]').forEach((button) => {
        button.addEventListener('click', () => {
          sendMessage(button.getAttribute('data-adres-assistant-prompt'));
        });
      });
      root.querySelectorAll('[data-adres-assistant-whatsapp]').forEach((link) => {
        link.addEventListener('click', () => track('adres_assistant_whatsapp_click'));
      });
      updateCart({
        item_count: config.cartItemCount,
        total_price: config.cartTotalPrice
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-collection-discovery')) {
    customElements.define('am-collection-discovery', class extends HTMLElement {
      connectedCallback() {
        this.viewport = matchMedia('(min-width: 990px)');
        this.syncViewport = () => {
          this.querySelector('details').open = this.viewport.matches;
          this.toggleAttribute('data-desktop', this.viewport.matches);
        };
        this.syncViewport();
        this.viewport.addEventListener('change', this.syncViewport);
      }
      disconnectedCallback() {
        this.viewport.removeEventListener('change', this.syncViewport);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-sale-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-sale-rail')) {
    customElements.define('collection-sale-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const list = this.querySelector('.collection-sale__items');
        const controls = this.querySelector('.collection-sale__controls');
        const buttons = [...controls.querySelectorAll('button')];
        const update = () => {
          const max = list.scrollWidth - list.clientWidth;
          controls.hidden = max <= 2;
          buttons[0].disabled = list.scrollLeft <= 2;
          buttons[1].disabled = list.scrollLeft >= max - 2;
        };
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-sale-direction]');
          if (!button) return;
          list.scrollBy({ left: Number(button.dataset.saleDirection) * list.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.abort.signal });
        list.addEventListener('scroll', update, { passive: true, signal: this.abort.signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(list);
        update();
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.abort = null;
        if (this.observer) this.observer.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-cookie-consent]')
    const opener = document.querySelector('[data-cookie-open]')
    if (!root || !opener) return

    const analyticsInput = root.querySelector('[data-cookie-analytics]')
    const status = root.querySelector('[data-cookie-status]')
    const details = root.querySelector('[data-cookie-details]')
    const rejectedSessionKey = 'adres_cookie_rejected_this_session'
    let privacy

    const wasRejectedThisSession = () => {
      try {
        return window.sessionStorage.getItem(rejectedSessionKey) === 'true'
      } catch (error) {
        return false
      }
    }

    const rememberSessionDecision = (analyticsAllowed) => {
      try {
        if (analyticsAllowed) {
          window.sessionStorage.removeItem(rejectedSessionKey)
        } else {
          window.sessionStorage.setItem(rejectedSessionKey, 'true')
        }
      } catch (error) {
        // Consent remains fail-closed even when sessionStorage is unavailable.
      }
    }

    const show = () => {
      root.hidden = false
      opener.hidden = true
    }

    const hide = () => {
      root.hidden = true
      opener.hidden = false
    }

    const applyStoredConsent = () => {
      const consent = privacy.currentVisitorConsent()
      const allowed = consent.analytics === 'yes'
      analyticsInput.checked = allowed
      const marketingNeedsReset = consent.marketing === 'yes' || consent.sale_of_data === 'yes'
      if (marketingNeedsReset || consent.analytics === '') {
        show()
        return
      }
      if (typeof window.amApplyStoreConsent === 'function') window.amApplyStoreConsent(allowed)
      if (allowed || wasRejectedThisSession()) {
        hide()
      } else {
        show()
      }
    }

    const save = (analyticsAllowed) => {
      status.textContent = ''
      if (!privacy) {
        status.textContent = 'Çerez tercihleri şu anda kaydedilemedi. İsteğe bağlı araçlar kapalı tutuluyor.'
        return
      }
      privacy.setTrackingConsent({
        analytics: analyticsAllowed,
        marketing: false,
        preferences: false,
        sale_of_data: false
      }, () => {
        rememberSessionDecision(analyticsAllowed)
        const shouldReload = !analyticsAllowed && window.amStoreTagManagerLoaded
        if (typeof window.amApplyStoreConsent === 'function') window.amApplyStoreConsent(analyticsAllowed)
        hide()
        if (shouldReload) window.location.reload()
      })
    }

    root.querySelector('[data-cookie-reject]').addEventListener('click', () => save(false))
    root.querySelector('[data-cookie-accept]').addEventListener('click', () => save(true))
    root.querySelector('[data-cookie-save]').addEventListener('click', () => save(analyticsInput.checked))
    opener.addEventListener('click', () => {
      show()
      details.open = true
      root.querySelector('summary').focus()
    })

    const loadPrivacy = () => {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        status.textContent = 'Çerez tercihleri şu anda yüklenemedi. İsteğe bağlı araçlar kapalı tutuluyor.'
        show()
        return
      }

      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error || !window.Shopify.customerPrivacy) {
          status.textContent = 'Çerez tercihleri şu anda kaydedilemedi. İsteğe bağlı araçlar kapalı tutuluyor.'
          show()
          return
        }
        privacy = window.Shopify.customerPrivacy
        document.documentElement.classList.add('am-cookie-consent-ready')
        applyStoredConsent()
      })
    }

    show()
    loadPrivacy()
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dependent-collection-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('popstate', this.onHistory);
          return;
        }
        this.initialized = true;
        this.loadingLabel = this.querySelector('[data-filter-status]').textContent;
        this.addEventListener('change', event => {
          const input = event.target;
          if (!input.form || !input.form.matches('[data-collection-filter-form]')) return;
          event.stopPropagation();
          this.apply(input.form);
        });
        this.addEventListener('submit', event => {
          if (!event.target.matches('[data-collection-filter-form]')) return;
          event.preventDefault();
          this.apply(event.target);
        });
        this.addEventListener('click', event => {
          const link = event.target.closest('.active-filter');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.refresh(new URL(link.href));
        });
        this.onHistory = () => this.refresh(new URL(window.location.href), false);
        window.addEventListener('popstate', this.onHistory);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onHistory);
        if (this.controller) this.controller.abort();
      }

      apply(form) {
        if (!form.reportValidity() || this.loading) return;
        const url = new URL(form.action);
        for (const [name, value] of new FormData(form)) {
          if (value !== '' && name !== 'page') url.searchParams.append(name, value);
        }
        this.refresh(url);
      }

      sectionUrl(url) {
        const request = new URL(url);
        request.hash = '';
        request.search += (request.search ? '&' : '?') + 'section_id=' + encodeURIComponent(this.dataset.sectionId);
        return request;
      }

      async refresh(url, pushHistory = true) {
        if (this.loading && pushHistory) return;
        if (this.controller) this.controller.abort();
        const controller = new AbortController();
        this.controller = controller;
        const timer = window.setTimeout(() => controller.abort(), 15000);
        const groups = [...this.querySelectorAll('[data-filter-key]')].map(group => ({
          key: group.dataset.filterKey, open: group.open,
          scroll: group.querySelector('.filter-list') ? group.querySelector('.filter-list').scrollTop : 0
        }));
        const mobileFilters = this.querySelector('.filters');
        const mobileOpen = mobileFilters ? mobileFilters.classList.contains('is-open') : false;
        const focused = document.activeElement;
        const focus = this.contains(focused) ? {
          name: focused.name, value: focused.value, range: focused.dataset.lengthRange
        } : null;
        const scroll = window.scrollY;
        this.loading = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-collection-filter-form]').inert = true;
        this.querySelector('[name="sort_by"]').disabled = true;
        const loadingStatus = this.querySelector('[data-filter-status]');
        loadingStatus.textContent = this.loadingLabel;
        loadingStatus.classList.remove('visually-hidden');
        loadingStatus.hidden = false;
        try {
          const response = await fetch(this.sectionUrl(url), { signal: controller.signal });
          if (!response.ok) throw new Error('Filter request failed');
          const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = documentNext.querySelector('collection-filters');
          if (!next || next.dataset.sectionId !== this.dataset.sectionId) throw new Error('Missing collection section');
          if (this.controller !== controller) return;
          this.innerHTML = next.innerHTML;
          for (const state of groups) {
            const group = [...this.querySelectorAll('[data-filter-key]')].find(item => item.dataset.filterKey === state.key);
            if (!group) continue;
            group.open = state.open;
            const list = group.querySelector('.filter-list');
            if (list) list.scrollTop = state.scroll;
          }
          if (mobileOpen) {
            this.querySelector('.filters').classList.add('is-open');
            this.querySelector('[data-filter-toggle]').setAttribute('aria-expanded', 'true');
          }
          if (pushHistory && url.href !== window.location.href) window.history.pushState(null, '', url);
          if (focus) {
            const replacement = [...this.querySelectorAll('input, select')].find(input => focus.range !== undefined
              ? input.dataset.lengthRange === focus.range
              : input.name === focus.name && input.value === focus.value);
            if (replacement) replacement.focus({ preventScroll: true });
          }
          window.scrollTo({ top: scroll, behavior: 'instant' });
          const status = this.querySelector('[data-filter-status]');
          status.textContent = this.querySelector('[data-filter-count]').textContent;
          status.classList.add('visually-hidden');
          status.hidden = false;
        } catch (error) {
          if (this.controller === controller && this.isConnected) window.location.assign(url.href);
        } finally {
          window.clearTimeout(timer);
          if (this.controller === controller) {
            this.loading = false;
            this.removeAttribute('aria-busy');
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["length-range-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('length-range-filter')) {
    customElements.define('length-range-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        this.dataset.enhanced = 'true';
        this.querySelectorAll('[data-length-range-option]').forEach(option => { option.hidden = false; });
        this.querySelectorAll('[data-length-exact-option]').forEach(option => { option.hidden = true; });
        this.addEventListener('change', event => {
          const range = event.target.closest('[data-length-range]');
          if (!range) return;
          event.stopPropagation();
          this.querySelectorAll('[data-length-exact]').forEach(input => {
            if (input.dataset.lengthExact === range.dataset.lengthRange) input.checked = range.checked;
          });
          if (range.form) range.form.requestSubmit();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-media-gallery')) {
    customElements.define('am-media-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.media-gallery__track');
        this.trackWidth = this.track.clientWidth;
        this.slides = [...this.querySelectorAll('.media-gallery__slide')];
        this.images = [...this.querySelectorAll('[data-gallery-image]')];
        this.count = this.querySelector('[data-gallery-count]');
        this.thumbs = [...this.querySelectorAll('[data-gallery-index]')];
        this.steps = [...this.querySelectorAll('[data-gallery-step]')];
        this.renderedIndex = null;
        this.dialog = this.querySelector('dialog');
        this.canvas = this.querySelector('[data-lightbox-canvas]');
        this.index = 0;
        this.imageIndex = 0;
        this.querySelectorAll('[data-gallery-controls]').forEach(el => { el.hidden = false; });
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-gallery-image]');
          if (opener && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
            event.preventDefault();
            this.opener = opener;
            this.imageIndex = this.images.indexOf(opener);
            this.showImage();
            this.dialog.showModal();
            return;
          }
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          if (button.hasAttribute('data-gallery-step')) this.go(this.index + Number(button.dataset.galleryStep));
          if (button.hasAttribute('data-gallery-index')) this.go(Number(button.dataset.galleryIndex));
          if (button.hasAttribute('data-lightbox-step')) {
            this.imageIndex = Math.max(0, Math.min(this.images.length - 1, this.imageIndex + Number(button.dataset.lightboxStep)));
            this.showImage();
          }
          if (button.hasAttribute('data-lightbox-close')) this.dialog.close();
          if (button.hasAttribute('data-lightbox-zoom')) {
            const zoomed = this.dialog.toggleAttribute('data-zoomed');
            button.setAttribute('aria-pressed', String(zoomed));
            button.textContent = zoomed ? 'Uzaklaştır' : 'Yakınlaştır';
            this.canvas.scrollTo(0, 0);
          }
        }, {signal});
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (!this.trackWidth) return;
            this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.trackWidth)));
            this.update();
          });
        }, {passive: true, signal});
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (event.target.closest('video, iframe, model-viewer, input, textarea')) return;
          if (this.dialog.hasAttribute('data-zoomed')) return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          if (this.dialog.open) {
            this.imageIndex = Math.max(0, Math.min(this.images.length - 1, this.imageIndex + step));
            this.showImage();
          } else this.go(this.index + step);
        }, {signal});
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, {signal});
        this.dialog.addEventListener('close', () => { this.canvas.replaceChildren(); if (this.opener) this.opener.focus({preventScroll:true}); }, {signal});
        const selected = this.slides.findIndex(slide => slide.dataset.mediaId === this.dataset.initialMedia);
        if (selected > 0) this.go(selected, 'instant');
        this.resize = new ResizeObserver(([entry]) => {
          const width = entry.contentRect.width;
          if (!width || width === this.trackWidth) return;
          this.trackWidth = width;
          this.go(this.index, 'instant');
        });
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort.abort(); this.resize.disconnect(); cancelAnimationFrame(this.frame); }
      go(index, behavior) {
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({left: this.index * this.trackWidth, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth')});
        this.update();
      }
      update() {
        if (this.renderedIndex === this.index) return;
        this.renderedIndex = this.index;
        const count = `${this.index + 1} / ${this.slides.length}`;
        if (this.count && this.count.textContent !== count) this.count.textContent = count;
        this.thumbs.forEach((button, index) => {
          if (index === this.index) {
            if (button.getAttribute('aria-current') !== 'true') button.setAttribute('aria-current', 'true');
          } else if (button.hasAttribute('aria-current')) button.removeAttribute('aria-current');
        });
        this.steps.forEach(button => {
          const disabled = Number(button.dataset.galleryStep) < 0 ? this.index === 0 : this.index === this.slides.length - 1;
          if (button.disabled !== disabled) button.disabled = disabled;
        });
      }
      showImage() {
        const source = this.images[this.imageIndex];
        if (!source) return;
        const image = new Image();
        image.className = 'media-lightbox__image';
        image.alt = source.dataset.imageAlt;
        image.style.setProperty('--media-source-width', `${Number(source.dataset.imageWidth)}px`);
        image.style.setProperty('--media-source-height', `${Number(source.dataset.imageHeight)}px`);
        image.src = source.href;
        this.canvas.replaceChildren(image);
        this.dialog.removeAttribute('data-zoomed');
        const zoom = this.querySelector('[data-lightbox-zoom]');
        zoom.textContent = 'Yakınlaştır';
        zoom.setAttribute('aria-pressed', 'false');
        this.querySelector('[data-lightbox-count]').textContent = `${this.imageIndex + 1} / ${this.images.length}`;
        this.querySelector('[data-lightbox-caption]').textContent = source.dataset.imageAlt;
        this.querySelectorAll('[data-lightbox-step]').forEach(button => { button.disabled = Number(button.dataset.lightboxStep) < 0 ? this.imageIndex === 0 : this.imageIndex === this.images.length - 1; });
        this.canvas.scrollTo(0, 0);
        this.go(this.slides.indexOf(source.closest('.media-gallery__slide')), 'instant');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    const configNode = document.getElementById('ThemeRuntimeConfig')
    if (!configNode) return

    const config = JSON.parse(configNode.textContent)
    const sectionSelector = '[data-section-refresh]'
    const query = (selector, scope = document) => scope.querySelector(selector)
    const queryAll = (selector, scope = document) => [...scope.querySelectorAll(selector)]

    document.documentElement.classList.add('js')

    const announce = (scope, message) => {
      const card = scope.closest ? scope.closest('.product-card') : null
      const target = query('[data-form-message]', scope) || (card && query('[data-form-message]', card)) || query('[data-global-message]')
      if (target) target.textContent = message
    }

    const dispatch = (name, detail = {}) => {
      document.dispatchEvent(new CustomEvent(name, { detail }))
    }

    const syncProductForms = (cartState) => {
      queryAll('[data-product-form]').forEach((form) => {
        const submit = query('[type="submit"]', form)
        const buyNow = query('[data-buy-now]', form)
        const quantity = query('input[name="quantity"]', form)
        const available = form.dataset.variantAvailable === 'true'
        if (quantity && quantity.type === 'number') {
          quantity.disabled = !available
        }
        if (submit) {
          submit.disabled = !available || form.dataset.submitting === 'true'
          if (form.dataset.addLabel) submit.textContent = form.dataset.addLabel
        }
        if (buyNow) buyNow.disabled = !available || form.dataset.submitting === 'true'
      })
    }

    const refreshSections = async () => {
      const sections = queryAll(sectionSelector)
      const ids = [...new Set(sections.map((node) => node.dataset.sectionRefresh).filter(Boolean))]
      if (!ids.length) return

      const sectionUrl = new URL(window.location.href)
      sectionUrl.searchParams.set('sections', ids.join(','))
      const response = await fetch(sectionUrl, {
        headers: { Accept: 'text/html' },
        cache: 'no-store'
      })
      if (!response.ok) throw new Error(config.cartError)
      const payload = await response.json()
      if (ids.some((id) => typeof payload[id] !== 'string')) throw new Error(config.cartError)
      const openDrawer = query('#CartDrawer[open]')
      const noteInput = query('[data-cart-note]')
      const pendingNote = noteInput ? noteInput.value : null
      const focused = document.activeElement
      const focusedCartItem = focused && focused.closest ? focused.closest('.cart-item') : null
      const focusedQuantityInput = focusedCartItem ? focusedCartItem.querySelector('[data-cart-quantity]') : null
      const focusedLine = focusedQuantityInput ? focusedQuantityInput.dataset.line : null
      const focusedStep = focused ? focused.dataset.quantityChange : null
      const focusedQuantity = focused ? focused.matches('[data-cart-quantity]') : false

      ids.forEach((id) => {
        const html = payload[id]
        if (!html) return
        const parsed = new DOMParser().parseFromString(html, 'text/html')
        const replacement = query(`${sectionSelector}[data-section-refresh="${CSS.escape(id)}"]`, parsed)
        const current = query(`${sectionSelector}[data-section-refresh="${CSS.escape(id)}"]`)
        if (replacement && current) current.replaceWith(replacement)
      })
      const refreshedNote = query('[data-cart-note]')
      if (refreshedNote && pendingNote !== undefined) {
        refreshedNote.value = pendingNote
        if (focused === noteInput) {
          refreshedNote.focus({ preventScroll: true })
          refreshedNote.setSelectionRange(noteInput.selectionStart, noteInput.selectionEnd)
        }
      }
      if (openDrawer) {
        const drawer = query('#CartDrawer')
        if (drawer && !drawer.open) drawer.showModal()
        const lineInput = drawer && focusedLine ? query(`[data-cart-quantity][data-line="${CSS.escape(focusedLine)}"]`, drawer) : null
        const focusTarget = focusedQuantity ? lineInput : focusedStep && lineInput ? query(`[data-quantity-change="${CSS.escape(focusedStep)}"]`, lineInput.closest('[data-quantity-control]')) : null
        if (focusTarget) focusTarget.focus({ preventScroll: true })
      }
    }

    const openDialog = (dialog) => {
      if (!dialog || dialog.open) return
      dialog.showModal()
    }

    const mountDeferredDialog = (id) => {
      const template = document.getElementById(`${id}-Template`)
      if (!template || !template.content) return null
      document.body.append(template.content.cloneNode(true))
      return document.getElementById(id)
    }

    const closeDialog = (dialog) => {
      if (dialog && dialog.open) dialog.close()
    }

    const ageGate = query('[data-age-gate]')
    if (ageGate && !config.designMode) {
      const logoImage = query('.age-gate__logo-image', ageGate)
      const logoFallback = query('[data-age-logo-fallback]', ageGate)
      const showLogoFallback = () => {
        if (logoImage) logoImage.hidden = true
        if (logoFallback) logoFallback.hidden = false
      }
      if (logoImage) {
        logoImage.addEventListener('error', showLogoFallback)
        if (logoImage.complete && !logoImage.naturalWidth) showLogoFallback()
      }

      const storageKey = 'am_age_verified_at'
      const retentionDays = Number(ageGate.dataset.retentionDays)
      const retention = (Number.isInteger(retentionDays) && retentionDays >= 1 && retentionDays <= 90 ? retentionDays : 30) * 86400000
      const now = Date.now()
      let storedValue = null
      try {
        storedValue = window.localStorage.getItem(storageKey)
      } catch {
        storedValue = null
      }
      const verifiedAt = Number(storedValue)
      const hasValidVerification = typeof storedValue === 'string' &&
        /^\d+$/.test(storedValue) &&
        Number.isFinite(verifiedAt) &&
        Number.isSafeInteger(verifiedAt) &&
        verifiedAt > 0 &&
        verifiedAt <= now &&
        now - verifiedAt < retention

      ageGate.addEventListener('cancel', (event) => event.preventDefault())
      if (!hasValidVerification) {
        try {
          window.localStorage.removeItem(storageKey)
        } catch {}
        openDialog(ageGate)
        const heading = query('#AgeGateTitle', ageGate)
        if (heading) heading.focus({ preventScroll: true })
      }
      const acceptButton = query('[data-age-accept]', ageGate)
      if (acceptButton) acceptButton.addEventListener('click', () => {
        try {
          window.localStorage.setItem(storageKey, String(Date.now()))
        } catch {}
        closeDialog(ageGate)
        const mainContent = document.getElementById('MainContent')
        if (mainContent) mainContent.focus({ preventScroll: true })
        dispatch('am:age:verified')
      })
    }

    const openCartDrawer = () => openDialog(query('#CartDrawer'))

    const parseError = async (response) => {
      try {
        const payload = await response.json()
        return payload.description || payload.message || config.cartError
      } catch {
        return config.cartError
      }
    }

    document.addEventListener('click', async (event) => {
      const opener = event.target.closest('[data-dialog-open]')
      if (opener) {
        let dialog = document.getElementById(opener.dataset.dialogOpen)
        if (!dialog) dialog = mountDeferredDialog(opener.dataset.dialogOpen)
        if (dialog) {
          event.preventDefault()
          openDialog(dialog)
        }
        return
      }

      const closer = event.target.closest('[data-dialog-close]')
      if (closer) {
        event.preventDefault()
        closeDialog(closer.closest('dialog'))
        return
      }

      const quantityButton = event.target.closest('[data-quantity-change]')
      if (quantityButton) {
        const control = quantityButton.closest('[data-quantity-control]')
        const input = query('input[type="number"]', control)
        if (!input || input.disabled) return
        const minimum = Number(input.min || 0)
        const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY
        const change = Number(quantityButton.dataset.quantityChange)
        input.value = String(Math.min(maximum, Math.max(minimum, Number(input.value || minimum) + change)))
        input.dispatchEvent(new Event('change', { bubbles: true }))
        return
      }

      const filterToggle = event.target.closest('[data-filter-toggle]')
      if (filterToggle) {
        const filters = document.getElementById(filterToggle.dataset.filterToggle)
        if (filters) {
          const expanded = filters.classList.toggle('is-open')
          filterToggle.setAttribute('aria-expanded', String(expanded))
        }
        return
      }

      const removeButton = event.target.closest('[data-cart-remove]')
      if (removeButton) {
        event.preventDefault()
        removeButton.setAttribute('aria-busy', 'true')
        try {
          const response = await fetch(config.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(removeButton.dataset.line), quantity: 0 })
          })
          if (!response.ok) throw new Error(await parseError(response))
          const cartState = await response.json()
          await refreshSections()
          syncProductForms(cartState)
          dispatch('am:cart:updated', { source: 'remove' })
        } catch (error) {
          announce(document, error.message || config.cartError)
        } finally {
          removeButton.removeAttribute('aria-busy')
        }
      }
    })

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]')
      if (!form || !window.fetch) return

      event.preventDefault()
      const submitButton = query('[type="submit"]', form)
      const buyNowButton = query('[data-buy-now]', form)
      const buyNow = event.submitter === buyNowButton && Boolean(buyNowButton)
      if (form.dataset.submitting === 'true') return
      if (form.dataset.variantAvailable !== 'true') {
        announce(form, form.dataset.addLabel || config.cartError)
        return
      }

      form.dataset.submitting = 'true'
      const formData = new FormData(form)
      const requested = Number(formData.get('quantity') || 1)
      let latestCart

      if (submitButton) submitButton.setAttribute('aria-busy', 'true')
      if (submitButton) submitButton.setAttribute('disabled', '')
      if (buyNowButton) buyNowButton.setAttribute('disabled', '')
      if (buyNow) buyNowButton.setAttribute('aria-busy', 'true')
      announce(form, config.loadingMessage)

      try {
        const cartResponse = await fetch(config.cartUrl, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        })
        if (!cartResponse.ok) throw new Error(await parseError(cartResponse))
        const cartState = await cartResponse.json()
        latestCart = cartState
        const variantId = Number(formData.get('id'))
        const existingVariantQuantity = cartState.items
          .filter((item) => Number(item.variant_id) === variantId)
          .reduce((total, item) => total + Number(item.quantity), 0)

        const response = await fetch(config.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
        if (!response.ok) throw new Error(await parseError(response))
        const item = await response.json()
        const updatedCartResponse = await fetch(config.cartUrl, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        })
        if (!updatedCartResponse.ok) throw new Error(config.cartError)
        const updatedCartState = await updatedCartResponse.json()
        latestCart = updatedCartState
        const updatedVariantQuantity = updatedCartState.items
          .filter((cartItem) => Number(cartItem.variant_id) === variantId)
          .reduce((total, cartItem) => total + Number(cartItem.quantity), 0)
        if (buyNow && updatedVariantQuantity < existingVariantQuantity + requested) {
          throw new Error(config.cartError)
        }
        announce(form, config.addedMessage)
        if (!buyNow) {
          await refreshSections()
          openCartDrawer()
        }
        dispatch('am:product:add', {
          productId: item.product_id,
          variantId: item.variant_id,
          quantity: item.quantity
        })
        if (buyNow) window.location.assign(config.checkoutUrl)
      } catch (error) {
        announce(form, error.message || config.cartError)
      } finally {
        form.dataset.submitting = 'false'
        if (submitButton) submitButton.removeAttribute('aria-busy')
        if (buyNowButton) buyNowButton.removeAttribute('aria-busy')
        if (submitButton) submitButton.removeAttribute('disabled')
        if (buyNowButton) buyNowButton.removeAttribute('disabled')
        if (latestCart) syncProductForms(latestCart)
      }
    })

    let cartUpdateTimer
    document.addEventListener('change', (event) => {
      const sort = event.target.closest('[data-auto-submit]')
      if (sort) {
        if (sort.form) sort.form.requestSubmit()
        return
      }

      const cartInput = event.target.closest('[data-cart-quantity]')
      if (!cartInput || !window.fetch) return

      const maximum = cartInput.max ? Number(cartInput.max) : Number.POSITIVE_INFINITY
      const minimum = Number(cartInput.min || 0)
      const requested = Number(cartInput.value || minimum)
      const quantity = Math.min(maximum, Math.max(minimum, requested))
      cartInput.value = String(quantity)

      window.clearTimeout(cartUpdateTimer)
      cartUpdateTimer = window.setTimeout(async () => {
        cartInput.setAttribute('aria-busy', 'true')
        try {
          const response = await fetch(config.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(cartInput.dataset.line), quantity })
          })
          if (!response.ok) throw new Error(await parseError(response))
          const cartState = await response.json()
          await refreshSections()
          syncProductForms(cartState)
          dispatch('am:cart:updated', { source: 'quantity' })
        } catch (error) {
          try {
            await refreshSections()
          } catch {
            cartInput.value = cartInput.defaultValue
          }
          announce(document, error.message || config.cartError)
        } finally {
          cartInput.removeAttribute('aria-busy')
        }
      }, 250)
    })

    const optionRequests = new WeakMap()
    document.addEventListener('change', async (event) => {
      const option = event.target.closest('[data-option-value]')
      if (!option) return

      const section = option.closest('[data-product-section]')
      if (!section) return

      const existingRequest = optionRequests.get(section)
      if (existingRequest) existingRequest.abort()
      const controller = new AbortController()
      optionRequests.set(section, controller)

      const valueIds = queryAll('[data-option-value]:checked', section).map((input) => input.value)
      const url = new URL(section.dataset.productUrl, window.location.origin)
      url.searchParams.set('option_values', valueIds.join(','))
      url.searchParams.set('section_id', section.dataset.sectionId)
      section.setAttribute('aria-busy', 'true')

      try {
        const response = await fetch(url, { signal: controller.signal })
        if (!response.ok) throw new Error(config.cartError)
        const html = await response.text()
        const parsed = new DOMParser().parseFromString(html, 'text/html')
        const replacement = query('[data-product-section]', parsed)
        if (!replacement) throw new Error(config.cartError)
        section.replaceWith(replacement)
        const variantId = replacement.dataset.variantId
        const browserUrl = new URL(replacement.dataset.productUrl, window.location.origin)
        if (variantId) browserUrl.searchParams.set('variant', variantId)
        window.history.replaceState({}, '', browserUrl)
      } catch (error) {
        if (error.name !== 'AbortError') announce(section, config.cartError)
      } finally {
        section.removeAttribute('aria-busy')
      }
    })

    let searchTimer
    let searchController
    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-predictive-search]')
      if (!input) return

      const target = document.getElementById(input.getAttribute('aria-controls'))
      const term = input.value.trim()
      window.clearTimeout(searchTimer)
      if (searchController) searchController.abort()

      if (term.length < 2) {
        if (target) {
          target.hidden = true
          target.innerHTML = ''
        }
        input.setAttribute('aria-expanded', 'false')
        return
      }

      searchTimer = window.setTimeout(async () => {
        searchController = new AbortController()
        input.setAttribute('aria-busy', 'true')
        try {
          const url = new URL(config.predictiveSearchUrl, window.location.origin)
          url.searchParams.set('q', term)
          url.searchParams.set('resources[type]', 'product,collection,page,article')
          url.searchParams.set('resources[limit]', '6')
          url.searchParams.set('resources[options][unavailable_products]', 'hide')
          url.searchParams.set('section_id', 'predictive-search')
          const response = await fetch(url, { signal: searchController.signal })
          if (!response.ok) throw new Error(config.cartError)
          const html = await response.text()
          if (target) {
            target.innerHTML = html
            target.hidden = false
          }
          input.setAttribute('aria-expanded', 'true')
          dispatch('am:predictive-search', { term })
        } catch (error) {
          if (error.name !== 'AbortError' && target) target.hidden = true
        } finally {
          input.removeAttribute('aria-busy')
        }
      }, 180)
    })

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return
      queryAll('[data-predictive-panel]:not([hidden])').forEach((panel) => {
        panel.hidden = true
      })
      queryAll('[data-predictive-search][aria-expanded="true"]').forEach((input) => input.setAttribute('aria-expanded', 'false'))
    })

    document.addEventListener('click', (event) => {
      if (event.target.closest('.header-search')) return
      queryAll('[data-predictive-panel]:not([hidden])').forEach((panel) => {
        panel.hidden = true
      })
      queryAll('[data-predictive-search][aria-expanded="true"]').forEach((input) => input.setAttribute('aria-expanded', 'false'))
    })

    document.addEventListener('shopify:section:load', () => {
      queryAll('dialog[open]').forEach((dialog) => {
        if (dialog !== ageGate) closeDialog(dialog)
      })
    })
  })()
  } catch(e) { console.error(e); }
})();

})();
